import React, { useState, useCallback, useMemo } from "react";
import "./style.scss";
import MediaCard, { MediaFileContent } from "../MediaCard";
import { BsCloudUpload } from "react-icons/bs";

import { useDropzone } from "react-dropzone";
import UserNotification from "../../../../../../../shared/components/Notification/UserNotification";
import {
  useWorkShop,
  WorkshopSectionContent,
  WorkshopSectionContentType,
} from "../../../../../../../contexts/workshop-context/WorkshopContext";
import getIconByType from "../../../../../../../shared/resources/file-types/file-types";
import { DraggableProvided } from "react-beautiful-dnd";

interface IProps {
  resource: WorkshopSectionContent;
  provided: DraggableProvided;
  onFileSelected?(file: File): void;
  onUploading?(status: boolean): void;
  uploading?: boolean;
  updateCurrentAction: (
    isEditing: boolean,
    isUploading: boolean,
    allowNavigation: boolean
  ) => void;
}

const MediaFile = (props: IProps) => {
  const { onFileSelected, updateCurrentAction } = props;
  const [uploadElement, setUploadElement] = useState(null as any);
  const { setResourceFileName } = useWorkShop();

  const onDrop = useCallback(
    (files) => {
      const file: any = files ? files[0] : null;
      const fileType = file?.name
        .split(".")
        .pop()
        ?.toLowerCase();
      const exList = "xls,pptx,ppt,png,pdf,jpg,jpeg,gif,docx,doc,xlsx,txt,md".split(
        ","
      );

      let b1 = file && exList.filter((ext) => ext === fileType).length > 0;
      let b2 = file && file?.size <= 105255200;
      let errorMessage = "";
      if (b1) errorMessage = "Invalid file format";
      if (b2) errorMessage = " Invalid file size";
      if (b1 && b2) {
        if (file) {
          onFileSelected && onFileSelected(file);
          setResourceFileName(props.resource, file?.name);
          updateCurrentAction(true, false, false);
        }
      } else {
        UserNotification({
          isSuccess: false,
          message: errorMessage,
        });
      }
    },
    [onFileSelected, updateCurrentAction, setResourceFileName, props.resource]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  const getFile: any = useMemo(() => {
    const getFileContent = (content: string): MediaFileContent => {
      try {
        const data: MediaFileContent = JSON.parse(content);
        if (data) {
          return data;
        } else {
          return { fileName: data, url: data, type: "all" };
        }
      } catch (e) {
        return { fileName: content, url: content, type: "all" };
      }
    };

    return (resource: WorkshopSectionContent) => {
      if (resource.type === WorkshopSectionContentType.IMAGE_URL) {
        return (
          <img
            style={{ width: "200px" }}
            src={getFileContent(resource.content).url}
            alt=""
          />
        );
      } else {
        return (
          <>
            <img
              src={getIconByType(getFileContent(resource.content).type)}
              alt=""
              style={{ width: "25px", marginRight: "10px" }}
            />
            <a
              href={getFileContent(resource.content).url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getFileContent(resource.content).fileName}
            </a>
          </>
        );
      }
    };
  }, []);
  return (
    <MediaCard
      updateCurrentAction={props.updateCurrentAction}
      resource={props.resource}
      fileNotSelected={props.resource.fileName?.length === 0}
      onUploading={props.onUploading}
      uploading={props.uploading}
      provided={props.provided}
    >
      <div {...getRootProps()}>
        {props.resource.mode === "EDIT" ? (
          <div
            className={
              isDragActive
                ? "media-file-wrapper back-animate"
                : "media-file-wrapper "
            }
          >
            <div
              className="d-flex align-items-center justify-content-between"
              style={{ minWidth: "600px" }}
            >
              <BsCloudUpload />
              <div className="texts">
                {props.resource.content.length > 1 && (
                  <div className="after-select-file">
                    Choose another file by browsing again.
                  </div>
                )}
                <div
                  className="before-select-file text-truncate"
                  style={{ maxWidth: "400px" }}
                >
                  {props.resource.fileName && props.resource.fileName !== ""
                    ? props.resource.fileName
                    : "Drag and drop a file here"}
                </div>
              </div>
              {!props.uploading && (
                <div style={{ marginLeft: "5px" }}>
                  <button
                    onClick={() => {
                      uploadElement.click();
                    }}
                  >
                    Browse a file
                  </button>
                </div>
              )}
              <input
                {...getInputProps()}
                type="file"
                ref={(input) => setUploadElement(input)}
                accept=".xls, .pptx, .ppt, .png, .pdf, .jpg, .jpeg, .gif, .docx, .doc, .xlsx, .txt, .md"
                className="d-none"
                onChange={(e) => {
                  const file: any = e.target.files ? e.target.files[0] : null;
                  const fileType = file?.name
                    .split(".")
                    .pop()
                    .toLowerCase();
                  const exList = "xls,pptx,ppt,png,pdf,jpg,jpeg,gif,docx,doc,xlsx,txt,md".split(
                    ","
                  );

                  let b1 =
                    file && exList.filter((ext) => ext === fileType).length > 0;
                  let b2 = file && file?.size <= 105255200;
                  let errorMessage = "No file was selected";
                  if (b1) errorMessage = "Invalid file format";
                  if (b2) errorMessage = " Invalid file size";
                  if (b1 && b2) {
                    if (file) {
                      props.onFileSelected && props.onFileSelected(file);
                      setResourceFileName(props.resource, file?.name);
                      props.updateCurrentAction(true, false, false);
                    }
                  } else {
                    UserNotification({
                      isSuccess: false,
                      message: errorMessage,
                    });
                  }
                }}
              />
            </div>
          </div>
        ) : (
          <div className="text-center resource-preview-wrapper">
            <div className="resource-preview">{getFile(props.resource)}</div>
          </div>
        )}
      </div>
    </MediaCard>
  );
};

export default MediaFile;
